import React from "react";
import classnames from "classnames";

import "./index.scss";

export type ToolbarProps = React.PropsWithChildren<{ variant?: "outlined"; className?: string }>;

export type ToolbarComponent = {
  Left: React.FC<React.PropsWithChildren>;
  Right: React.FC<React.PropsWithChildren>;
  Filters: React.FC<React.PropsWithChildren>;
  Item: React.FC<React.PropsWithChildren>;
};

const Left: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="toolbar-left">{children}</div>;
};

const Right: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="toolbar-right">{children}</div>;
};

const Filters: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="toolbar-filters">{children}</div>;
};

const Item: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="toolbar-item">{children}</div>;
};

export const Toolbar: React.FC<ToolbarProps> & ToolbarComponent = ({ children, className, variant }) => {
  return (
    <div className={classnames("page-toolbar", className, { [`page-toolbar-${variant}`]: variant })}>{children}</div>
  );
};

Toolbar.Left = Left;

Toolbar.Right = Right;

Toolbar.Filters = Filters;

Toolbar.Item = Item;

export default Toolbar;
